// config.js

// Postal code tiers for pricing
export const POSTAL_TIERS = {
    tier1PostalRanges: [
      { min: '00100', max: '00990' }, // Helsinki
      { min: '02100', max: '02980' }, // Espoo
      { min: '01300', max: '01930' }, // Vantaa
      { min: '33100', max: '33960' }, // Tampere
      { min: '20100', max: '20960' }  // Turku
    ],
    tier2PostalRanges: [
      { min: '90100', max: '90999' }, // Oulu
      { min: '40100', max: '40999' }, // Jyväskylä
      { min: '50100', max: '50999' }, // Mikkeli
      { min: '70100', max: '70999' }, // Kuopio
      { min: '15100', max: '15999' }  // Lahti
    ],
    tier3PostalRanges: [
      { min: '80100', max: '80999' }, // Joensuu
      { min: '65100', max: '65999' }  // Vaasa
    ]
  }
  
  export const SIZE_TIERS = [
    {
      size: "XXS",
      max_dimensions: { length: 3, width: 25, height: 40 }, // cm
      base_price: 4.90
    },
    {
      size: "XS", 
      max_dimensions: { length: 6, width: 25, height: 40 }, // cm
      base_price: 5.70
    },
    {
      size: "S",
      max_dimensions: { length: 10, width: 40, height: 55 }, // cm
      base_price: 6.00
    },
    {
      size: "M",
      max_dimensions: { length: 20, width: 40, height: 55 }, // cm
      base_price: 8.00
    },
    {
      size: "L",
      max_dimensions: { length: 35, width: 40, height: 55 }, // cm
      base_price: 13.80
    },
    {
      size: "XL",
      max_dimensions: { length: 70, width: 40, height: 55 }, // cm
      base_price: 22.80
    }
  ];

  // myXline (MXL) settings - same day delivery
  export const MXL_SETTINGS = {
    enabled: true,
    price: 19.90,
    maxDimensions: { length: 150, width: 150, height: 150 }, // cm
    weightRestriction: 80000, // 80kg in grams
    cutoffTime: "2:00 PM",
    enabledDays: {
      monday: true,
      tuesday: true,
      wednesday: true,
      thursday: true,
      friday: true,
      saturday: true,
      sunday: true
    },
    tierSurcharges: {
      tier1: 0,
      tier2: 10,
      tier3: 20
    },
    homeDeliverySurcharge: 10 // Additional cost for home delivery vs pickup
  };
  
  // MatkaHuolto (MH) settings - basic delivery
  export const MH_SETTINGS = {
    enabled: true,
    price: 4.9,
    weightRestriction: 30000, // 30kg in grams
    maxDimensions: { length: 70, width: 40, height: 55 }, // cm
    enabledDays: {
      monday: true,
      tuesday: true,
      wednesday: true,
      thursday: true,
      friday: true,
      saturday: false,
      sunday: false
    },
  };
  